module.exports = __webpack_public_path__ + "img/google-play.8bd3bc6d.png";